import Axios from 'axios';
import {Utilities} from "../utilities";

export class TeamMembers {

  constructor() {
    // Team members row.
    this.teamMembersRow = document.getElementById("team-members-row");

    // Text search elements.
    this.teamMemberTextSearch = document.getElementById("team-member-text-search");
    this.teamMemberTextSearchButton = document.getElementById("team-member-text-search-button");

    // Dropdown searches.
    this.teamMemberDepartmentSearch = document.getElementById("team-members-department-search");
    this.teamMemberLocationSearch = document.getElementById("team-members-location-search");
    this.teamMemberTeamSearch = document.getElementById("team-members-team-search");
    this.teamMemberServiceSearch = document.getElementById("team-members-service-search");
    this.teamMemberRoleSearch = document.getElementById("team-members-role-search");

    //  Reset search button.
    this.teamMemberResetSearchButton = document.getElementById("team-member-reset-search-button");

    // Each team member wrapper.
    this.teamMembers = document.querySelectorAll(".team-member-wrapper");

    // Check if team member offset is defined.
    this.loadAllTeamMembers();
    this.setEventListeners();
  }

  /**
   * Set all of our event listeners.
   */
  setEventListeners() {
    const _self = this;

    // Bind our text search button.
    if (_self.teamMemberTextSearchButton !== null && _self.teamMemberTextSearch !== null) {
      _self.teamMemberTextSearchButton.addEventListener("click", function (e) {
        e.preventDefault();
        _self.getTeamMembersByTextSearchButtonClick();
      });
      _self.teamMemberTextSearch.addEventListener("keydown", function (e) {
        if(e.key === "Enter") {
          e.preventDefault();
          _self.getTeamMembersByTextSearchButtonClick();
        }
      });
    }

    // Reset search. Let us get all people by text search but not have any value set in the text box.
    if (_self.teamMemberResetSearchButton !== null) {
      _self.teamMemberResetSearchButton.addEventListener("click", function (e) {
        e.preventDefault();
        _self.resetTeamMemberSearchFilters();
      });
    }

    // Bind our department search.
    if (_self.teamMemberDepartmentSearch !== null) {
      _self.teamMemberDepartmentSearch.addEventListener("change", function (e) {
        e.preventDefault();
        _self.filterTeamMembersByTaxonomyDropdownChange();
      });
    }

    // Bind our locations dropdown.
    if (_self.teamMemberLocationSearch !== null) {
      _self.teamMemberLocationSearch.addEventListener("change", function (e) {
        e.preventDefault();
        _self.filterTeamMembersByTaxonomyDropdownChange();
      });
    }

    // Bind our teams dropdown.
    if (_self.teamMemberTeamSearch !== null) {
      _self.teamMemberTeamSearch.addEventListener("change", function (e) {
        e.preventDefault();
        _self.filterTeamMembersByTaxonomyDropdownChange();
      });
    }

    // Bind our services dropdown.
    if (_self.teamMemberServiceSearch !== null) {
      _self.teamMemberServiceSearch.addEventListener("change", function (e) {
        e.preventDefault();
        _self.filterTeamMembersByTaxonomyDropdownChange();
      });
    }

    // Bind our roles dropdown.
    if (_self.teamMemberRoleSearch !== null) {
      _self.teamMemberRoleSearch.addEventListener("change", function (e) {
        e.preventDefault();
        _self.filterTeamMembersByTaxonomyDropdownChange();
      });
    }
  }

  /**
   * Filter our team members by dropdown change.
   */
  filterTeamMembersByTaxonomyDropdownChange() {
    const _self = this;

    let teamMembers = document.querySelectorAll(".single-team-member-wrap");
    let departmentValue = "";
    let teamValue = "";
    let locationValue = "";
    let serviceValue = "";
    let roleValue = "";

    if (_self.teamMemberTeamSearch !== null) {
      teamValue = _self.teamMemberTeamSearch.value;
    }

    if (_self.teamMemberLocationSearch !== null) {
      locationValue = _self.teamMemberLocationSearch.value;
    }

    if (_self.teamMemberDepartmentSearch !== null) {
      departmentValue = _self.teamMemberDepartmentSearch.value;
    }

    if (_self.teamMemberServiceSearch !== null) {
      serviceValue = _self.teamMemberServiceSearch.value;
    }

    if (_self.teamMemberRoleSearch !== null) {
      roleValue = _self.teamMemberRoleSearch.value;
    }

    // Determine if the reset button should be shown.
    _self.determineIfResetButtonShouldBeShown();

    if (teamMembers.length) {
      // First let us filter out team members by each value.
      for (let i = 0; i < teamMembers.length; i++) {
        // Let us get our attribute values for this team member.
        _self.updateTeamMemberDisplayClass(teamValue, teamMembers[i].dataset.taxonomyTeams, teamMembers[i], "d-none-tax-teams");
        _self.updateTeamMemberDisplayClass(locationValue, teamMembers[i].dataset.taxonomyLocations, teamMembers[i], "d-none-tax-locations");
        _self.updateTeamMemberDisplayClass(departmentValue, teamMembers[i].dataset.taxonomyDepartments, teamMembers[i], "d-none-tax-departments");
        _self.updateTeamMemberDisplayClass(serviceValue, teamMembers[i].dataset.taxonomyServices, teamMembers[i], "d-none-tax-services");
        _self.updateTeamMemberDisplayClass(roleValue, teamMembers[i].dataset.taxonomyRoles, teamMembers[i], "d-none-tax-roles");
      }

      _self.disableDropdownOptions();
    }
  }


  /**
   * Disable dropdowns that need to be disabled.
   */
  disableDropdownOptions() {
    const _self = this;
    // Let us get a collection of all the visible team members.
    let visibleTeamMembers = _self.getVisibleTeamMembers();

    // Build a list of options that are not disabled per each dropdown option.
    // Then iterate over each select options and cross reference with our list we have.
    if (visibleTeamMembers.length) {
      // Team Member Filter.
      if (_self.teamMemberTeamSearch !== null) {
        let teamOptionsThatAreNotDisabled = _self.getListOfOptionsThatAreNotDisabled(visibleTeamMembers, "teams");

        const teamOptions = _self.teamMemberTeamSearch.options;
        _self.disableOptionsThatAreNotInList(teamOptions, teamOptionsThatAreNotDisabled);
      }

      // Department Filter.
      if (_self.teamMemberDepartmentSearch !== null) {
        let departmentsOptionsThatAreNotDisabled = _self.getListOfOptionsThatAreNotDisabled(visibleTeamMembers, "departments");

        const departmentOptions = _self.teamMemberDepartmentSearch.options;
        _self.disableOptionsThatAreNotInList(departmentOptions, departmentsOptionsThatAreNotDisabled);
      }

      // Location Filter.
      if (_self.teamMemberLocationSearch !== null) {
        let locationOptionsThatAreNotDisabled = _self.getListOfOptionsThatAreNotDisabled(visibleTeamMembers, "locations");

        const locationOptions = _self.teamMemberLocationSearch.options;
        _self.disableOptionsThatAreNotInList(locationOptions, locationOptionsThatAreNotDisabled);
      }

      // Service Filter.
      if (_self.teamMemberServiceSearch !== null) {
        let servicesOptionsThatAreNotDisabled = _self.getListOfOptionsThatAreNotDisabled(visibleTeamMembers, "services");

        const serviceOptions = _self.teamMemberServiceSearch.options;
        _self.disableOptionsThatAreNotInList(serviceOptions, servicesOptionsThatAreNotDisabled);
      }

      // Role Filter.
      if (_self.teamMemberRoleSearch !== null) {
        let rolesOptionsThatAreNotDisabled = _self.getListOfOptionsThatAreNotDisabled(visibleTeamMembers, "roles");

        const roleOptions = _self.teamMemberRoleSearch.options;
        _self.disableOptionsThatAreNotInList(roleOptions, rolesOptionsThatAreNotDisabled);
      }
    }
  }

  /**
   * Disable options that are not in list.
   *
   * @param options
   * @param list
   */
  disableOptionsThatAreNotInList(options, list) {
    for (let i = 0; i < options.length; i++) {
      let disabled = true;

      // Do not disable the empty options.
      if (options[i].value === "") {
        disabled = false;
        continue;
      }

      for (let k = 0; k < list.length; k++) {
        if (list[k] === options[i].value) {
          disabled = false;
        }
      }

      options[i].disabled = disabled;
    }
  }

  /**
   * Get a list of options that are in the team members - typically visible.
   * @param teamMembers
   * @param taxType
   * @returns {*[]}
   */
  getListOfOptionsThatAreNotDisabled(teamMembers, taxType) {
    let optionsThatAreNotDisabled = [];
    let taxValues = undefined;

    for (let i = 0; i < teamMembers.length; i++) {
      switch (taxType) {
        case "teams":
          taxValues = teamMembers[i].dataset.taxonomyTeams;
          break;
        case "locations":
          taxValues = teamMembers[i].dataset.taxonomyLocations;
          break;
        case "services":
          taxValues = teamMembers[i].dataset.taxonomyServices;
          break;
        case "departments":
          taxValues = teamMembers[i].dataset.taxonomyDepartments;
          break;
        case "roles":
          taxValues = teamMembers[i].dataset.taxonomyRoles;
          break;
      }


      if (taxValues === undefined) {
        continue;
      }

      taxValues = taxValues.split(',');

      // Now that we have a comma separated list of taxonomies for teams, let us add them to our list.
      for (let j = 0; j < taxValues.length; j++) {
        if (optionsThatAreNotDisabled.includes(taxValues[j]) === false) {
          optionsThatAreNotDisabled.push(taxValues[j]);
        }
      }
    }

    return optionsThatAreNotDisabled;
  }

  /**
   * Get an array of visible team members.
   *
   * @returns {*[]}
   */
  getVisibleTeamMembers() {
    let hiddenClasses = ["d-none-tax-teams", "d-none-tax-locations", "d-none-tax-departments", "d-none-tax-services", "d-none-tax-roles"];
    let teamMembers = document.querySelectorAll(".single-team-member-wrap");
    let visibleTeamMembers = [];

    if (teamMembers.length) {
      for (let j = 0; j < teamMembers.length; j++) {
        let isTeamMemberVisible = true;

        for (let k = 0; k < hiddenClasses.length; k++) {
          if (teamMembers[j].classList.contains(hiddenClasses[k])) {
            // Add our visible team member to our array. Will iterate later.
            isTeamMemberVisible = false;
          }
        }

        if (isTeamMemberVisible) {
          visibleTeamMembers.push(teamMembers[j]);
        }
      }
    }

    return visibleTeamMembers;
  }

  /**
   * Update team members to be hidden or visible.
   *
   * @param dropdownValue
   * @param taxValues
   * @param teamElem
   * @param displayClass
   */
  updateTeamMemberDisplayClass(dropdownValue, taxValues, teamElem, displayClass) {
    // Let us set our tax values to either an empty array or split the values on the comma.
    if (taxValues === undefined) {
      taxValues = [];
    } else {
      taxValues = taxValues.split(',');
    }

    if (dropdownValue === "") {
      teamElem.classList.remove(displayClass);
    } else {
      if (taxValues.includes(dropdownValue)) {
        teamElem.classList.remove(displayClass);
      } else {
        teamElem.classList.add(displayClass);
      }
    }
  }

  /**
   * Resets the filters and gets a fresh list of team members.
   */
  resetTeamMemberSearchFilters() {
    const _self = this;

    if (_self.teamMemberTextSearch !== null) {
      _self.teamMemberTextSearch.value = "";
    }

    if (_self.teamMemberLocationSearch !== null) {
      _self.teamMemberLocationSearch.value = "";
    }

    if (_self.teamMemberTeamSearch !== null) {
      _self.teamMemberTeamSearch.value = "";
    }

    if (_self.teamMemberDepartmentSearch !== null) {
      _self.teamMemberDepartmentSearch.value = "";
    }

    if (_self.teamMemberServiceSearch !== null) {
      _self.teamMemberServiceSearch.value = "";
    }

    if (_self.teamMemberRoleSearch !== null) {
      _self.teamMemberRoleSearch.value = "";
    }

    // Hide the reset button to prevent multiple clicks.
    _self.determineIfResetButtonShouldBeShown();

    // This resets our team members row will all team members and shows the loader and hides the loader.
    _self.getTeamMembersTextSearch("");
  }

  /**
   * Get our team members on button search click.
   */
  getTeamMembersByTextSearchButtonClick() {
    const _self = this;

    if (_self.canBeTeamMemberPage() === false) {
      return;
    }

    if (_self.teamMemberTextSearch === null) {
      return;
    }

    let searchString = _self.teamMemberTextSearch.value;
    _self.getTeamMembersTextSearch(searchString);
  }

  /**
   * Get team members by text search.
   *
   * @param searchString
   */
  getTeamMembersTextSearch(searchString = "") {
    const _self = this;

    // Show loader.
    Utilities.showLoader();

    // Disable all inputs.
    _self.shouldDisableAllInputs(true);

    // Let us clear out our team wrapper.
    _self.teamMembersRow.innerHTML = "";

    // Let us make a server call to get our data by text.
    Axios({
      method: 'get',
      url: wp.ajax_url,
      params: {
        text_search: searchString,
        action: "get_team_members_text_search"
      }
    }).then(function (response) {
      _self.teamMembersRow.innerHTML += response.data;
      // Enable and show reset button. They did a text search.
      _self.determineIfResetButtonShouldBeShown();

      // Enable all inputs.
      _self.shouldDisableAllInputs(false);

      // Hide loader.
      Utilities.hideLoader();
    }).catch(function (error) {
      console.log(error);
      // Enable and show reset button. They did a text search.
      _self.determineIfResetButtonShouldBeShown();

      // Show all inputs.
      _self.shouldDisableAllInputs(false);

      // Hide loader.
      Utilities.hideLoader();
    });
  }

  /**
   * Hide and enable reset button.
   */
  determineIfResetButtonShouldBeShown() {
    let textValue = "";
    let teamValue = "";
    let locationValue = "";
    let departmentValue = "";
    let serviceValue = "";
    let roleValue = "";

    if (this.teamMemberTextSearch !== null) {
      textValue = this.teamMemberTextSearch.value;
    }

    if (this.teamMemberTeamSearch !== null) {
      teamValue = this.teamMemberTeamSearch.value;
    }

    if (this.teamMemberLocationSearch !== null) {
      locationValue = this.teamMemberLocationSearch.value;
    }

    if (this.teamMemberDepartmentSearch !== null) {
      departmentValue = this.teamMemberDepartmentSearch.value;
    }

    if (this.teamMemberServiceSearch !== null) {
      serviceValue = this.teamMemberServiceSearch.value;
    }

    if (this.teamMemberRoleSearch !== null) {
      roleValue = this.teamMemberRoleSearch.value;
    }

    // If any input has a value, show the reset button.
    if (this.teamMemberResetSearchButton !== null) {
      if (textValue !== "" || teamValue !== "" || locationValue !== "" || departmentValue !== "" || serviceValue !== "" || roleValue !== "") {
        this.teamMemberResetSearchButton.classList.remove("d-none");
      } else {
        this.teamMemberResetSearchButton.classList.add("d-none");
      }
    }
  }

  /**
   * Disable reset button.
   */
  disableResetButton() {
    if (this.teamMemberResetSearchButton !== null) {
      this.teamMemberResetSearchButton.disabled = true;
    }
  }

  /**
   * Enable reset button.
   */
  enableResetButton() {
    if (this.teamMemberResetSearchButton !== null) {
      this.teamMemberResetSearchButton.disabled = false;
    }
  }

  /**
   * Hide or show all inputs.
   *
   * @param shouldDisable
   */
  shouldDisableAllInputs(shouldDisable) {
    if (this.teamMemberTextSearchButton !== null) {
      this.teamMemberTextSearchButton.disabled = shouldDisable;
    }

    if (this.teamMemberTextSearch !== null) {
      this.teamMemberTextSearch.disabled = shouldDisable;
    }

    if (this.teamMemberLocationSearch !== null) {
      this.teamMemberLocationSearch.disabled = shouldDisable;
    }

    if (this.teamMemberTeamSearch !== null) {
      this.teamMemberTeamSearch.disabled = shouldDisable;
    }

    if (this.teamMemberDepartmentSearch !== null) {
      this.teamMemberDepartmentSearch.disabled = shouldDisable;
    }

    if (this.teamMemberServiceSearch !== null) {
      this.teamMemberServiceSearch.disabled = shouldDisable;
    }

    if (this.teamMemberRoleSearch !== null) {
      this.teamMemberRoleSearch.disabled = shouldDisable;
    }

    // Re-enable all hidden/grayed out options.
    this.disableDropdownOptions();
  }

  /**
   * Load team members. Gets called on page load.
   */
  loadAllTeamMembers() {
    const _self = this;

    if (_self.canBeTeamMemberPage() === false) {
      return;
    }

    Utilities.showLoader();

    Axios({
      method: 'get',
      url: wp.ajax_url,
      params: {
        action: "get_team_members"
      }
    }).then(function (response) {
      _self.teamMembersRow.innerHTML += response.data;
      _self.removeDisabledAttrsFromAll();
      Utilities.hideLoader();
    }).catch(function (error) {
      console.log(error);
      _self.removeDisabledAttrsFromAll();
      Utilities.hideLoader();
    });
  }

  /**
   * Check if the page loaded can be the teams page by checking if certain elements are present.
   *
   * The required items are:
   *  - If an element with an id of "team-members-row" exists.
   * @returns {boolean}
   */
  canBeTeamMemberPage() {
    const _self = this;
    let canBeTeamPage = true;

    if (_self.teamMembersRow === null) {
      canBeTeamPage = false;
    }

    return canBeTeamPage;
  }

  /**
   * Remove disabled attributes from all form controls.
   */
  removeDisabledAttrsFromAll() {
    const _self = this;

    if (_self.teamMemberLocationSearch !== null) {
      _self.teamMemberLocationSearch.disabled = false;
    }

    if (_self.teamMemberTeamSearch !== null) {
      _self.teamMemberTeamSearch.disabled = false;
    }

    if (_self.teamMemberDepartmentSearch !== null) {
      _self.teamMemberDepartmentSearch.disabled = false;
    }

    if (_self.teamMemberServiceSearch !== null) {
      _self.teamMemberServiceSearch.disabled = false;
    }

    if (_self.teamMemberRoleSearch !== null) {
      _self.teamMemberRoleSearch.disabled = false;
    }

    if (_self.teamMemberTextSearchButton !== null) {
      _self.teamMemberTextSearchButton.disabled = false;
    }

    if (_self.teamMemberTextSearch !== null) {
      _self.teamMemberTextSearch.disabled = false;
    }
  }
}

const teamMembers = new TeamMembers();